import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router';
import style from './style.module.less';

const logos1 = [
    {
        image: require('!file!./logos/karin-und-uwe-hollweg-stiftung.svg'),
        title: 'Karin und Uwe Hollweg Stiftung',
        size: 'big',
    },
    {
        image: require('!file!./logos/Der-Senator-fur-Kultur.png'),
        title: 'Der Senator für Kultur, freie Hansestadt Bremen',
        link: 'https://www.kultur.bremen.de/',
        size: 'big',
    },
    {
        image: require('!file!./logos/blg-logistics.svg'),
        title: 'BLG Logistics',
        link: 'https://www.blg-logistics.com/de',
        size: 'big',
    },
    {
        image: require('!file!./logos/fonds-soziokultur.svg'),
        title: 'Fonds Soziokultur',
        link: 'https://www.fonds-soziokultur.de/',
        size: 'big',
    },
    {
        image: require('!file!./logos/neusta.svg'),
        title: 'Team Neustra',
        link: 'https://www.team-neusta.de/',
        size: 'big',
    },
    {
        image: require('!file!./logos/justus-grosse.svg'),
        title: 'Justus Grosse',
        link: 'https://justus-grosse.de',
        size: 'big',
    },
    {
        image: require('!file!./logos/union.svg'),
        title: 'Union Brauerei',
    },
    {
        image: require('!file!./logos/beirat-woltmershausen.svg'),
        title: 'Beirat Woltmershausen',
    },
    {
        image: require('!file!./logos/sparkasse.png'),
        title: 'Sparkasse Bremen',
        link: 'https://www.sparkasse-bremen.de/',
    },
    {
        image: require('!file!./logos/sturken.svg'),
        title: 'Stürken',
        link: 'https://www.stuerken.com/',
    },
    {
        image: require('!file!./logos/waller-geschaftsleute.svg'),
        title: 'Waller Geschäftsleute',
    },
    {
        image: require('!file!./logos/plutex.svg'),
        title: 'Plutex',
        link: 'https://www.plutex.de/',
    },
    {
        image: require('!file!./logos/CWC.png'),
        title: 'CWC',
        link: 'http://www.cwcsys.de/',
    },
    {
        image: require('!file!./logos/ZZZ.png'),
        title: 'ZZZ',
        link: 'https://www.zzz-bremen.de/ueber-uns/',
    },
    {
        image: require('!file!./logos/Veranstaltungstechnik-Wiedemeyer.png'),
        title: 'Veranstaltungstechnik Wiedemeyer',
    },
];

const logos2 = [
    {
        image: require('!file!./logos/kulturhaus-pusdorf.svg'),
        title: 'Kulturhaus Pusdorf',
        link: 'https://www.kulturhaus-pusdorf.de/startseite.html',
    },
    {
        image: require('!file!./logos/echt-walle.svg'),
        title: 'Echt Walle',
    },
    {
        image: require('!file!./logos/wk-bike.svg'),
        title: 'WK bike',
        link: 'https://www.wk-bike.de/de/bremen/',
    },
    {
        image: require('!file!./logos/DieAbfahrer.png'),
        title: 'Die Abfahrer',
        link: 'http://www.dieabfahrer.com/',
    },
    {
        image: require('!file!./logos/Klabauterbett_Fahnenlogo_schwarz.svg'),
        title: 'Klabauterbett',
        link: 'https://www.klabauterbett.de/',
    },
];

const logos3 = [
    {
        image: require('!file!./logos/karin-und-uwe-hollweg-stiftung.svg'),
        title: 'Karin und Uwe Hollweg Stiftung',
        size: 'big',
    },
    {
        image: require('!file!./logos/Der-Senator-fur-Kultur.png'),
        title: 'Der Senator für Kultur, freie Hansestadt Bremen',
        link: 'https://www.kultur.bremen.de/',
        size: 'big',
    },
    {
        image: require('!file!./logos/sparkasse.png'),
        title: 'Sparkasse Bremen',
        link: 'https://www.sparkasse-bremen.de/',
    },
];

const logos4 = [
    {
        image: require('!file!./logos/fonds-soziokultur.svg'),
        title: 'Fonds Soziokultur',
        link: 'https://www.fonds-soziokultur.de/',
        size: 'big',
    },
    {
        image: require('!file!./logos/Der-Senator-fur-Kultur.png'),
        title: 'Der Senator für Kultur, freie Hansestadt Bremen',
        link: 'https://www.kultur.bremen.de/',
        size: 'big',
    },
];

const logos5 = [
    
    {
        image: require('!file!./logos/BKM_2017_DTP.png'),
        title: 'BKM',
        link: 'https://www.bundesregierung.de/breg-de/bundesregierung/staatsministerin-fuer-kultur-und-medien',
        size: 'big',
    }, 
    {
        image: require('!file!./logos/BKM_Neustart_Kultur_Wortmarke_neg_RGB_RZ.png'),
        title: 'Neustart Kultur',
        link: 'https://www.initiative-musik.de/neustart-kultur/',
    },   
];

const logos6 = [
    {
        image: require('!file!./logos/karin-und-uwe-hollweg-stiftung.svg'),
        title: 'Karin und Uwe Hollweg Stiftung',
    },
    {
        image: require('!file!./logos/Ueberseeinsel_trans_4c.png'),
        title: 'Überseeinsel',
    },
    {
        image: require('!file!./logos/JG-Logo_Immobilien.jpg'),
        title: 'Justus Grosse',
    },
    {
        image: require('!file!./logos/sparkasse.png'),
        title: 'Sparkasse Bremen',
        link: 'https://www.sparkasse-bremen.de/',
    },
];

const logos7 = [
    {
        image: require('!file!./logos/DAKU_Logokombi_dunkelgrau_03.jpg'),
        title: 'Fonds Darstellende Künste',
        link: 'https://www.fonds-daku.de/',
    },
];

const logos8 = [
    {
        image: require('!file!./logos/fs.svg'),
        title: 'Fonds Soziokultur',
        link: 'https://www.fonds-soziokultur.de/',
    },
];

const logos9 = [
    {
        image: require('!file!./logos/IniMusik_logo_kurz_color.png'),
        title: 'Initiative Musik',
        link: 'https://www.initiative-musik.de/',
    },
];

const logos10 = [
    {
        image: require('!file!./logos/coronabedingteinvestitionen.svg'),
        title: 'Bundesverband Soziokultur'
    },
    {
        image: require('!file!./logos/pandemiebedingt-03.svg'),
        title: 'Neu Start Kultur',
    },
];

const logos11 = [
    {
        image: require('!file!./logos/Der-Senator-fur-Kultur.png'),
        title: 'Der Senator für Kultur, freie Hansestadt Bremen',
        link: 'https://www.kultur.bremen.de/',
        size: 'big',
    },
];

const logos12 = [
    {
        image: require('!file!./logos/00-Weser Kurier.png'),
        title: 'Weser Kurier',
        size: 'small',
    },
    {
        image: require('!file!./logos/00-Nordwestticket.png'),
        title: 'Nordwest Ticket',
        size: 'small',
    },
    {
        image: require('!file!./logos/00-ML-Eventwerk.png'),
        title: 'ML Eventwerk',
        link: 'https://www.ml-eventwerk.de/',
        size: 'small',
    },
    {
        image: require('!file!./logos/CWC.png'),
        title: 'CWC',
        link: 'http://www.cwcsys.de/',
    },
    {
        image: require('!file!./logos/logo-b-o_neu.png'),
        title: 'Böhme Götz Geske',
    },
];

function Footer() {
    return (
        <div className={style.container}>
            <p>Die Arbeit der Golden City UG 2022 wird unterstützt von</p>
            <Logos logos={logos6} />
            <p>– – –</p><br></br>
            <p>Wir freuen uns über Förderungen aus vier verschiedenen Bundesprogrammen:</p><br></br>
            <p>Das Projekt "All Eyes On Us" wird gefördert vom Fonds Darstellende Künste...</p>
            <Logos logos={logos7} /><br></br>
            <p>Das Projekt "TraumStadtZukunft" wird unterstützt vom Fonds Soziokultur...</p>
            <Logos logos={logos8} /><br></br>
            <p>Das Musik- und Festivalprogramm in der temporären Hafenbar Golden City wird 
gefördert von der Initiative Musik...</p>
            <Logos logos={logos9} /><br></br>
            <p>Panbemiebedingte Investitionen werden gefördert vom Bundesverband Soziokultur...</p>
            <Logos logos={logos10} />
            <p>– – –</p><br></br>
            <p>... alle vier Förderungen stammen aus Mitteln der Beauftragten der Bundesregierung für Kultur und Medien im Rahmen von NEUSTART KULTUR...</p>
            <Logos logos={logos5} /><br></br>
            <p>... die jeweiligen Komplementärmittel werden vom Senator für Kultur Bremen gestellt.</p>
            <Logos logos={logos11} /><br></br>
            <p>– – –</p><br></br>
            <p>Wir danken unseren Kooperationspartner*innen:</p>
            <Logos logos={logos12} /><br></br>
            <p>und allen, die unsere Arbeit mit weiteren Spenden an den Verein Goldene Stadt e.V. unterstützen! <br></br>IBAN DE 0529 0501 0100 8147 7523</p>
            <p>– – –</p><br></br>
            <Link to="/impressum/" className={style.impressum}>
                Impressum
            </Link>&nbsp;//&nbsp; 
            <Link to="/tickets/" className={style.impressum}>
                 GC APP
            </Link>&nbsp;//&nbsp;
            <Link to="/satzung/" className={style.impressum}>
                 Satzung  
            </Link>&nbsp;//&nbsp;
            <Link to="/foerdermitglied/" className={style.impressum}>
                 Werde Fördermitglied
            </Link>
            <br></br>
        </div>
    );
}

function Logos({ logos }) {
    return (
        <ul className={style.logos}>
            {logos.map(logo => {
                return (
                    <li key={logo.title} className={classNames({ [style.big]: logo.size === 'big' })}>
                        {logo.link
                            ? <a href={logo.link}>
                                  <img alt={logo.title} src={logo.image} />
                              </a>
                            : <img alt={logo.title} src={logo.image} />}
                    </li>
                );
            })}
        </ul>
    );
}

export default Footer;



// WEBPACK FOOTER //
// ../components/Footer/index.js